import appleModelsList from './actions/appleModelsList';
import getAppleModels from './getters/getAppleModels';
import appleModelsUpload from './mutations/appleModelsUpload';

const actions = {
    appleModelsList
};

const mutations = {
    appleModelsUpload
};

const getters = {
    getAppleModels
};

export default { actions, mutations, getters };
